
import DefaultController from '../controller';
import {createObjectFromDefault} from '../functions';

class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.type = 'arc';

    }


    
    
}

// you can extend a blue print for a parent component by importing it
// and using let Blueprint = Object.assign(parentBlueprint, {my: 'settings'});

let Blueprint = {
    type: Controller,
    properties: {   },
    events: {   },
    children: []
}

export default Blueprint;
export {Controller};
